import { Injectable } from '@angular/core';
import { AccountApiService, Integrationspartnersv1BatchGetAccountsRequest, Integrationspartnersv1BatchGetAccountsResponse } from '@blk/portfolio-security-server/account';
import { AccountInfoApiService, V1SearchExternalAccountInfosRequest, V1SearchExternalAccountInfosResponse } from '@blk/portfolio-security-server/accountInfo';
import { PlatformApiService, V1ExchangeAuthorizationCodeRequest, V1FilterPlatformsRequest, V1FilterPlatformsResponse } from '@blk/portfolio-security-server/platform';
import { Observable } from 'rxjs';
import { v4 as uuid } from 'uuid';

@Injectable({
	providedIn: 'root'
})
export class PartnerPortfoliosApiService {
	constructor(
		private platformApiService: PlatformApiService,
		private accountInfoService: AccountInfoApiService,
		private accountApiService: AccountApiService
	) { }

	/**
	 * Fetch partner platforms list - contains partner id and details along with partner auth url
	 *
	 * studio link - https://tst.blackrock.com/apps/studio/apis/agraph.wealth.integrations.partners.v1.PlatformAPI/spec#operation/PlatformAPI_FilterPlatforms
	 * @param {V1FilterPlatformsRequest} requestParams
	 * @returns {Observable<V1FilterPlatformsResponse>}
	 * @memberof PartnerPortfoliosApiService
	 */
	public fetchPlatformList(requestParams: V1FilterPlatformsRequest): Observable<V1FilterPlatformsResponse> {
		return this.platformApiService.platformAPIFilterPlatforms(uuid(), new Date().toISOString(), requestParams);
	}

	/**
	 * Exchange the authorization code for auth token to initiate the session 
	 *
	 * studio link - https://tst.blackrock.com/apps/studio/apis/agraph.wealth.integrations.partners.v1.PlatformAPI/spec#operation/PlatformAPI_ExchangeAuthorizationCode
	 * @param {string} familyId
	 * @returns {Observable<any>}
	 * @memberof PartnerPortfoliosApiService
	 */
	public exchangeAuthCode(requestParams: V1ExchangeAuthorizationCodeRequest): Observable<any> {
		return this.platformApiService.platformAPIExchangeAuthorizationCode(uuid(), new Date().toISOString(), requestParams);
	}

	/**
	 * api call to fetch the possible matches of accounts for user's search query
	 *
	 * studio link
	 * https://tst.blackrock.com/apps/studio/apis/agraph.wealth.integrations.partners.v1.ExternalAccountInfoAPI/spec#operation/ExternalAccountInfoAPI_SearchExternalAccountInfos
	 * @param {string} familyId
	 * @returns {Observable<any>}
	 * @memberof PartnerPortfoliosApiService
	 */
	public portfolioSearch(requestParams: V1SearchExternalAccountInfosRequest): Observable<V1SearchExternalAccountInfosResponse> {
		return this.accountInfoService.externalAccountInfoAPISearchExternalAccountInfos(uuid(), new Date().toISOString(), requestParams);
	}

	/**
	 * Batch get the selected account details
	 *
	 * studio link - https://tst.blackrock.com/apps/studio/apis/agraph.wealth.integrations.partners.v1.AccountAPI/spec#operation/AccountAPI_BatchGetAccounts
	 * @param {string} familyId
	 * @returns {Observable<any>}
	 * @memberof PartnerPortfoliosApiService
	 */
	public accountsBatchGet(requestParams: Integrationspartnersv1BatchGetAccountsRequest): Observable<Integrationspartnersv1BatchGetAccountsResponse> {
		return this.accountApiService.accountAPIBatchGetAccounts(uuid(), new Date().toISOString(), requestParams);
	}
}
